export enum MenuCommand {
  ToggleImageHeading,
  ToggleImageCaption,
  ToggleCrop,
  ReplaceImage,
  ChangeLinkUrl,
  ReplaceVideo,
}
